module.exports = __webpack_public_path__ + "img/b5.a3e98b3b.png";